import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.tsx";
import Menu from "../../components/layout/Menu.tsx";
import Footer from "../../components/layout/Footer.tsx";
import { onKeyActivate } from "../../utils/a11y.ts";

import {
  FaUserCog,
  FaUserSecret,
  FaHeadset,
  FaUsers,
  FaGraduationCap,
  FaCalendarDay,
  FaHandHoldingHeart,
  FaLaptop,
} from "react-icons/fa";
import { FaMagnifyingGlassChart } from "react-icons/fa6";
import { MdFeedback } from "react-icons/md";
import LoadingSpinner from "../../components/ui/LoadingSpinner.tsx";

const AdminGestao: React.FC = () => {
  const { loading, hasPermission } = useAuth();
  const navigate = useNavigate();

  if (loading) return <LoadingSpinner />;

  // Hub único de administração (RH consolidado aqui).
  // Cada card só aparece para quem tem o `.view`/`.manage` da tela.
  const modules = [
    {
      title: "Usuários",
      description: "Visualize e gerencie os usuários do Painel",
      icon: <FaUserCog />,
      path: "/admin/users",
      permission: "users.view",
    },
    {
      title: "Grupos & Permissões",
      description: "Gerencie grupos de usuário e suas permissões",
      icon: <FaUsers />,
      path: "/admin/groups",
      permission: "groups.view",
    },
    // {
    //   title: "Feedbacks",
    //   description:
    //     "Convide colaboradores a enviar feedbacks e gerencie os recebidos",
    //   icon: <MdFeedback />,
    //   path: "/admin/feedbacks",
    //   permission: "feedbacks.view",
    // },
    {
      title: "Central de Chamados",
      description: "Gerencie os tickets de suporte",
      icon: <FaHeadset />,
      path: "/admin/helpdesk",
      permission: "tickets.view",
    },
    {
      title: "Cursos",
      description:
        "Crie, edite ou exclua cursos para os demais usuários do Painel",
      icon: <FaGraduationCap />,
      path: "/admin/courses",
      permission: "courses.manage",
    },
    // {
    //   title: "Eventos",
    //   description: "Crie, edite ou exclua eventos para colaboradores internos",
    //   icon: <FaCalendarDay />,
    //   path: "/admin/calendar",
    //   permission: "events.manage",
    // },
    {
      title: "Estatísticas Ao Vivo",
      description:
        "Uso do Painel, Central de Chamados, Eneagrama e Cursos em um só lugar",
      icon: <FaMagnifyingGlassChart />,
      path: "/admin/statistics",
      permission: "analytics.view",
    },
    {
      title: "Logs de Atividade",
      description: "Visualize e gerencie os logs de atividade",
      icon: <FaUserSecret />,
      path: "/admin/logs",
      permission: "logs.view",
    },
    {
      title: "Mural de Elogios",
      description: "Apure e publique os elogios recebidos na urna",
      icon: <FaHandHoldingHeart />,
      path: "/admin/elogios",
      permission: "praises.view",
    },
    {
      title: "Inventário de TI",
      description: "Controle notebooks, celulares e com quem cada um está",
      icon: <FaLaptop />,
      path: "/admin/inventario-ti",
      permission: "it_assets.view",
    },
  ]
    .filter((m) => hasPermission(m.permission))
    .sort((a, b) => a.title.localeCompare(b.title, "pt-BR"));

  return (
    <div className="p-2">
      <Menu />
      <div className="content-area">
        <div className="page-header">
          <h2>Gestão de Admin</h2>
        </div>

        <div className="gestao-modules-grid">
          {modules.map((module, index) => (
            <div
              key={index}
              className="gestao-module-card"
              onClick={() => navigate(module.path)}
              onKeyDown={onKeyActivate(() => navigate(module.path))}
              role="button"
              tabIndex={0}
            >
              <div className="gestao-module-icon">{module.icon}</div>
              <h3>{module.title}</h3>
              <p>{module.description}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminGestao;
